// @flow
import React from 'react'
import { Link } from 'react-router-dom'

export const IncorrectPassword = (): any => {
  return (
    <div className='login'>
      <div className='login__header'>
        <i className='icon icon--logo' />
        <h3>The credentials you submitted were incorrect.</h3>
      </div>
      <h4>Please check the information you submitted and try again.</h4>
      <Link to='/' className='login__link'>Return to Login Page</Link>
    </div>
  )
}

IncorrectPassword.displayName = 'IncorrectPassword'

export default IncorrectPassword
